var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size sm_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: { click: _vm.btnClose }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.DASHBOARD.MAIN.CONTENTS")))]),
            _vm._v(" "),
            _c("em", { staticClass: "ico_info" }, [
              _c("i", { staticClass: "tooltip fl_btm" }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("MESSAGE.DASHBOARD.CONTENTS.TOOLTIP")) +
                    "\n                        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "choose_wrap" }, [
              _c("p", { staticClass: "q_opinion" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.DASHBOARD.DISPLAY.3CONTENTS")))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "choose_list" },
                [
                  _c("li", [
                    _c("label", { staticClass: "checkbox-wrap" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contentsList,
                            expression: "contentsList"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "contentsList",
                          value: "H"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.contentsList)
                            ? _vm._i(_vm.contentsList, "H") > -1
                            : _vm.contentsList
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.contentsList,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "H",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.contentsList = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.contentsList = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.contentsList = $$c
                              }
                            },
                            function($event) {
                              return _vm.changeCheck($event)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "check-icon" }),
                      _vm._v(" "),
                      _c("em", [
                        _vm._v(_vm._s(_vm.$t("FIELD.DASHBOARD.HOT.CONTENTS")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isASCUser
                    ? [
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "F"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "F") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "F",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FIELD.DASHBOARD.FAVORITE.CONTENT")
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "N"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "N") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "N",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FIELD.DASHBOARD.NEW.UPDATE.CONTENT")
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "S"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "S") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "S",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.SUPPORT")))
                            ])
                          ])
                        ])
                      ]
                    : [
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "W"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "W") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "W",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(_vm.$t("FIELD.DASHBOARD.WORKBOARD"))
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "S"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "S") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "S",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.SUPPORT")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.contentsList,
                                  expression: "contentsList"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "contentsList",
                                value: "N"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.contentsList)
                                  ? _vm._i(_vm.contentsList, "N") > -1
                                  : _vm.contentsList
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.contentsList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "N",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.contentsList = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.contentsList = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.contentsList = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.changeCheck($event)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FIELD.DASHBOARD.NEW.UPDATE.CONTENT")
                                )
                              )
                            ])
                          ])
                        ])
                      ]
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnClose }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnApply }
                  },
                  [
                    _vm._v(
                      "( " +
                        _vm._s(_vm.creRtnList().length) +
                        " / 3 ) " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.APPLY"))
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fed6c55e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fed6c55e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/dashboard/popup/ContentsConfigPopup.vue
// module id = 4DcF
// module chunks = 0